export default __webpack_public_path__ + "static/media/Monger-HUD-01.098301fd.jpg";